import { Container, Typography, Grid } from "@mui/material"
import { Box } from "@mui/system"
import benzinga from './benzinga-logo-white.svg';
import coinmarketcap from './sloarmc.png';
// import coinmarketcap from './coinmarketcap.png';
// import bloomberg from './bloomberg.png';
import bloomberg from './solarbr.png';
import marketePlace from './solarmw.png';
// import marketePlace from './marketePlace.png';
import yahoo_finance from './yahoo_finance_en-US_h_p_financev2.png';
export default () => {
    const sectionHeading = 'MEDIA MENTIONS'
    return (
        <Box pt={15} id="media">
            <Container sx={{ zIndex: '1' }}>
                <Box sx={{ position: 'relative', textAlign: 'center' }} mb={10}>
                    <Box > <span className="textStroke"><Typography color='white' fontSize={{ xs: '31px', sm: '50px', md: '74px' }} sx={{ letterSpacing: '0.12em' }}>
                        {sectionHeading}
                    </Typography></span></Box>
                    <Box sx={{ position: 'absolute', top: '10%', right: 0, left: 0, margin: 'auto' }}>
                        <Typography color='white' fontSize={{ xs: '25px', sm: '40px', md: '64px' }} sx={{ letterSpacing: '0.12em' }}>
                            {sectionHeading}
                        </Typography>
                    </Box>
                </Box>
            </Container>
            <Box maxWidth='lg' margin='auto'>
                <Grid container alignItems="center" justifyContent="space-around">


                    {/* {[
                        {
                            img: benzinga,
                            link: 'https://www.benzinga.com/pressreleases/21/11/23964052/solar-the-first-u-s-based-solana-dex'
                        }, {
                            img: coinmarketcap,
                            link: 'https://coinmarketcap.com/currencies/solardex/'
                        }, {
                            img: bloomberg,
                            link: 'https://www.bloomberg.com/press-releases/2021-11-08/solar-the-first-u-s-based-solana-dex'
                        }, {
                            img: marketePlace,
                            link: 'https://www.marketwatch.com/press-release/solar-the-first-us-based-solana-dex-2021-11-06'
                        }, {
                            img: yahoo_finance,
                            link: 'https://finance.yahoo.com/news/solar-first-u-based-solana-195700529.html'
                        }
                    ]
                    } */}
                    <Grid Item sx={{ color: 'white', textAlign: 'center' }} xs={12} sm={6} mb={5}>
                        <a target="_blank" href='https://www.benzinga.com/pressreleases/21/11/23964052/solar-the-first-u-s-based-solana-dex'>
                            <img src={benzinga} style={{ color: 'white' }} width="80%" style={{ maxWidth: '200px' }} />
                        </a>
                    </Grid>
                    <Grid Item sx={{ color: 'white', textAlign: 'center' }} xs={12} sm={6} mb={5}>
                        <a target="_blank" href='https://coinmarketcap.com/currencies/solardex/'>
                            <img src={coinmarketcap} style={{ color: 'white' }} width="80%" style={{ maxWidth: '200px' }} />
                        </a>
                    </Grid>





                    <Grid Item sx={{ color: 'white', textAlign: 'center' }} xs={12} mb={5}>
                        <a target="_blank" href='https://finance.yahoo.com/news/solar-first-u-based-solana-195700529.html'>
                            <img src={yahoo_finance} style={{ color: 'white' }} width="80%" style={{ maxWidth: '200px' }} />
                        </a>
                    </Grid>








                    <Grid Item sx={{ color: 'white', textAlign: 'center' }} xs={12} sm={6} mb={5}>
                        <a target="_blank" href='https://www.marketwatch.com/press-release/solar-the-first-us-based-solana-dex-2021-11-06'>
                            <img src={marketePlace} style={{ color: 'white' }} width="80%" style={{ maxWidth: '200px' }} />
                        </a>
                    </Grid>
                    <Grid Item sx={{ color: 'white', textAlign: 'center' }} xs={12} sm={6} mb={5}>
                       
                        <a target="_blank" href='https://www.bloomberg.com/press-releases/2021-11-08/solar-the-first-u-s-based-solana-dex'>
                            <img src={bloomberg} style={{ color: 'white' }} width="80%" style={{ maxWidth: '200px' }} />
                        </a>
                    </Grid>
                </Grid>
            </Box>
            {/* <Box maxWidth='lg' margin='auto' boxShadow='0px 0px 20px pink'>
                <Accordion sx={{background:'#56166F', color:'white'}}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                    >
                        <Typography>News 1</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography>
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse
                            malesuada lacus ex, sit amet blandit leo lobortis eget.
                        </Typography>
                    </AccordionDetails>
                </Accordion>
                <Accordion sx={{background:'#56166F', color:'white'}}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel2a-content"
                        id="panel2a-header"
                    >
                        <Typography>News 2</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography>
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse
                            malesuada lacus ex, sit amet blandit leo lobortis eget.
                        </Typography>
                    </AccordionDetails>
                </Accordion>
            </Box> */}
        </Box>
    )
}
